import React, { useEffect, useState, useRef } from 'react'

import styles from "./RefundForm.module.css"

import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import BreatheEV_Logo from '../../Images/logo.png';
import { Image } from 'react-bootstrap'
import { logout } from '../../Actions/Auth';


import Alert from '../../BootstrapComponents/Alert'
import { ButtonCustom } from '../../BootstrapComponents/ButtonCustom';
import { toast, ToastContainer } from 'react-toastify';
import { Link, Navigate, useParams, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons';
import { BreathAPIs } from '../../APIs/BreathAPIs';
import { FaCircleInfo } from "react-icons/fa6";
import { FaCheckCircle } from "react-icons/fa";




const RefundForm = (props) => {

    const [inprogress, setInprogress] = useState(false);
    const [message, setMessage] = useState({ type: '', message: '' });

    // supportID
    const { supportID } = useParams();

    useEffect(() => {
        const fetchRefund = async () => {
            if (props.isAuthenticated && supportID) {
                try {
                    setInprogress(true);
                    const response = await BreathAPIs.createSupportRefund(supportID);
                    const { message } = response.data;
                    setInprogress(false);
                    // Assuming response data has a message field
                    setMessage({ type: 'success', message });
                } catch (error) {
                    console.error("Error creating support refund:", error);
                    // Handle the error response
                    if (error.response) {
                        const { message } = error.response.data;
                        setMessage({ type: 'error', message });
                    } else {
                        setMessage({ type: 'error', message: 'Failed to process refund. Please try again later.' });
                    }
                    setInprogress(false);
                }
            }
        };

        fetchRefund();
    }, [props.isAuthenticated, supportID]);


    const location = useLocation();
    const path = location.pathname;

    if (props.loading || props.userType == null) {
        if (props.isAuthenticated === false) {
            return (<Navigate to={"/login?redirect=" + btoa(path)}  />)
        }
        return (<div className={'spinner'}><FontAwesomeIcon icon={faBolt} size="3x" /></div>);
    }

    return (
        <section className="bg-light py-3 py-md-5 py-xl-8 min-vh-100">
            <ToastContainer />
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4">
                        <div className="mb-5">
                            <div className="text-center mb-4">
                                <Image className={styles['logo']} src={BreatheEV_Logo} alt="" />
                            </div>
                        </div>
                        <div className="card border border-light-subtle rounded-4">
                            <div className="card-body p-3 p-md-4 p-xl-5">

                                {/* <h5 className={`mb-4 ${styles['refund-title']}`}>Refund</h5> */}
                                <div className="row gy-3 overflow-hidden">
                                    <div className="col-12">
                                        <div className="form-floating">
                                            {inprogress ?
                                                <div className={`${styles['message']}`}>
                                                    <div className={"spinner-border " + styles['spinner-block']} role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                    <div>Please waite requesting for your refund...</div>

                                                </div>
                                                :
                                                <div className={`${styles['message']} ${message?.type ? styles[message?.type] : ''}`}>
                                                    <div>{message?.type ==='success' ? <FaCheckCircle /> : <FaCircleInfo />}</div>
                                                    <div>{message.message}</div>
                                                </div>}
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="d-flex gap-2 gap-md-4 flex-column flex-md-row justify-content-md-center align-items-center mt-4">
                            <Link to={`${process.env.REACT_APP_BASE_URL}/`} className="link-secondary text-decoration-none">Back to Home</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );

}


RefundForm.propTypes = {
    isAuthenticated: PropTypes.bool,
    loading: PropTypes.bool,
    userType: PropTypes.string,
};

const mapStateToProps = (state) => ({
    isAuthenticated: state.auth.isAuthenticated,
    loading: state.auth.loading,
    userType: state.auth && state.auth.user ? state.auth.user.type : null,
});

export default connect(mapStateToProps, { logout })(RefundForm);